// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import './permission';
import '@/style/theme/index.css';
import '@/style/index.scss';
import '@/utils/iconfont.js';
import '@/utils/directives';
import '@/style/element.scss';
import * as validator from '@/utils/validator';
import IIcon from '@/components/common/IIcon';
import TableCustom from '@/components/common/TableCustom';

Vue.config.productionTip = false;

Vue.use(ElementUI, {size: 'small'});
Vue.component('IIcon', IIcon);
Vue.component('TableCustom', TableCustom);
Vue.prototype.$validator = validator;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js